import { Box, useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SettlementsKPIsResponseModel } from '../../../../api/Argentia/endpoints/settlements/model/settlements'
import { SettlementKpiItem } from '../settlementKpiItem/settlementKpiItem'

export type SettlementKpiType = 'all' | 'validated' | 'withObjections'

interface SettlementKpiRightContentProps {
  kpis?: SettlementsKPIsResponseModel
  isLoading: boolean
  /** KPI actualmente seleccionado */
  activeKpi?: SettlementKpiType | null
  /** Handler al hacer click en un KPI */
  onKpiClick?: (kpiType: SettlementKpiType) => void
}

export const SettlementKpiRightsContent: React.FC<SettlementKpiRightContentProps> = ({
  kpis,
  isLoading,
  activeKpi,
  onKpiClick
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'settlements'])
  const currentTheme = useTheme()
  const screenIsSmall = useMediaQuery(currentTheme.breakpoints.down('sm'))

  return (
    <Box style={{ height: '100%' }} display="flex" flexDirection="column" gridRowGap={16}>
      <Box
        style={{ height: '100%', rowGap: 16, columnGap: 16 }}
        display="flex"
        flexDirection={screenIsSmall ? 'column' : 'row'}
        flexWrap="wrap"
        justifyContent={'space-evenly'}
        alignItems="stretch"
        flexGrow={1}
      >
        <SettlementKpiItem
          id="validated"
          isLoading={isLoading}
          title={t('settlements:components.kpiCard.kpiItems.totalSettlementsValidated.title')}
          value={kpis?.totalSettlementsValidated}
          description={t(
            'settlements:components.kpiCard.kpiItems.totalSettlementsValidated.description'
          )}
          onClick={onKpiClick ? () => onKpiClick('validated') : undefined}
          isActive={activeKpi === 'validated'}
        />
        <SettlementKpiItem
          id="withObjections"
          isLoading={isLoading}
          title={t('settlements:components.kpiCard.kpiItems.totalSettlementsWithObjections.title')}
          value={kpis?.totalSettlementsWithObjections}
          description={t(
            'settlements:components.kpiCard.kpiItems.totalSettlementsWithObjections.description'
          )}
          onClick={onKpiClick ? () => onKpiClick('withObjections') : undefined}
          isActive={activeKpi === 'withObjections'}
        />
      </Box>
    </Box>
  )
}
